<template>
<div>
  <b-row>
    <b-colxx xxs="12">
        <div class="four-zero-three">
          <div class="four-zero-three__inner">
            <div class="four-zero-three__title">403!</div>
            <div class="four-zero-three__desc">การเข้าถึงถูกปฏิเสธ</div>
            <div class="four-zero-three__content">กรุณาตรวจสอบสิทธ์ของท่านหรือติดต่อผู้ดูแลระบบ</div>
          </div>
        </div>
    </b-colxx>

  </b-row>
  </div>
</template>
<script>
import items from '@/data/products'
export default {
  data () {
    return {
      menuRight : window.menuRight,
      previousPage : "",
      keyword: 'Cake',
      currentPage: 1,
      totalPage: 4,
      items,
    }
  },
  methods: {
    linkGen (pageNum) {
      return '#page-' + pageNum
    },
  },
  mounted () {
    this.previousPage = this.$route.query.p;

    $(document).ready(function() {
        document.title = 'Home';
    });
  }
}
</script>
<style scoped>
body { font-family: 'simple-line-icons'; }

.four-zero-three {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
}
.four-zero-three__inner {
    padding: 20px;
}
.four-zero-three__title {
    color: #000;
    font-size: 5rem;
    font-weight: bold;
    @media (max-width: $breakpoint-xs) {
      font-size: 4rem;
    }
}
.four-zero-three__desc {
    color: #e41919;
    font-size: 2.5rem;
    @media (max-width: $breakpoint-xs) {
      font-size: 2rem;
    }
  }
  .four-zero-three__content {
    font-size: 1.2rem;
    margin-bottom: 2rem;
    @media (max-width: $breakpoint-xs) {
      font-size: 1rem;
    }
  }
</style>
